<template>
  <transition name="selection-fade" @after-leave="handleAfterLeave">
    <div class="selection-content" :style="$commonMethod.customAppHeader(1, 0)" v-show="visible">
      <header>
        <van-nav-bar :left-arrow="true" @click-left="onClickLeft"
          :title="$t.buildWayBillNo.customsCommodityCode"></van-nav-bar>
      </header>

      <transition name="selection-fade">
        <customsCommodityCode :isSelection="true" @onSelected="handleSelected" @onClose="dismiss" class="entry-list"
          ref="list"></customsCommodityCode>
      </transition>
    </div>
  </transition>
</template>

<script>
import CustomsCommodityCode from "@/views/main/logisticsManagement/selection/customsCommodityCode";
export default {
  name: "CustomsCommodityCodeSelection",
  components: {
    CustomsCommodityCode,
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  destroyed() {
    document.body.style.overflow = null;
  },
  methods: {
    onClickLeft() {
      this.dismiss();
    },
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    handleSelected(data) {
      this.onSelected(data);
      this.dismiss();
    },
    onSelected(data) { },
    show() {
      this.visible = true;
    },
    dismiss() {
      this.visible = false;
      if (typeof this.onClose === "function") {
        this.onClose();
      }
    },
  },
};
</script>

<style scoped>
.selection-fade-enter,
.selection-fade-leave-active {
  transform: translateX(100%);
  opacity: 0;
}

.selection-content {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 999;
  transition: all 0.3s;
  overflow-y: hidden !important;
}

.entry-list {
  height: 100%;
  overflow: scroll;
}

.entry-list /deep/ .van-list {
  margin-bottom: calc(40vw + env(safe-area-inset-bottom));
}

header {
  overflow-y: hidden !important;
  background: linear-gradient(left, #009ed4, #5029c3);
}

header /deep/ .van-nav-bar {
  background: transparent;
  line-height: 2.5;
}

header /deep/ .van-nav-bar__content {
  overflow-y: hidden !important;
}

header /deep/ .van-nav-bar__title {
  color: #fff;
  font-size: 1.2rem;
}

header /deep/ .van-nav-bar__arrow {
  color: #fff;
  font-size: 2rem;
}

header /deep/ .van-hairline--bottom::after {
  display: none;
}
</style>
